<template>
  <div class="OrderAddressEdit" :class="{'disable-ske': !loading}">
    <span class="edit-button" v-if="!editing && order" @click="editing = true">
      <svg width="11" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
      </svg>
      <span class="ml-1">Wijzigen</span>
    </span>

    <div class="p-4">
      <table>
        <tbody>
<!--          <tr>
            <td class="bold">
              <span class="ske">
                Bedrijf:
              </span>
            </td>
            <CellEdit
              v-model="address.city"
              :editing="editing"
              :address="address"
            />
          </tr>-->
          <tr>
            <td class="bold">
              <span class="ske">
                BTW nummer:
              </span>
            </td>
            <td class="not-bold">
              <span class="ske">
                n.v.t
              </span>
            </td>
          </tr>
          <tr v-if="editing">
            <td class="bold">
              <span class="ske">
                Voornaam:
              </span>
            </td>
            <CellEdit
              v-model="address.firstName"
              :editing="editing"
              :address="address"
            />
          </tr>
          <tr v-if="editing">
            <td class="bold">
              <span class="ske">
                Achternaam:
              </span>
            </td>
            <CellEdit
              v-model="address.lastName"
              :editing="editing"
              :address="address"
            />
          </tr>
          <tr v-if="!editing">
            <td class="bold">
              <span class="ske">
                Contactpersoon:
              </span>
            </td>
            <td class="not-bold">
              <span class="ske">
                <span v-if="!address || (!address.firstname && address.lastname)">n.v.t</span>
                <span v-else>
                  <span v-if="address.firstName">{{ address.firstName }}</span>
                  <span v-if="address.lastName">{{ ' ' + address.lastName }}</span>
                </span>
                {{ address ? address.vatNumber : 'n.v.t' }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="bold">
              <span class="ske">
                E-mailadres:
              </span>
            </td>
            <CellEdit
              v-model="address.email"
              :editing="editing"
              :address="address"
            />
          </tr>
          <template v-if="editing">
            <tr v-for="(key, field) in addressFieldMap" :key="field">
              <td class="bold">
                <span class="ske">
                  {{ field }}:
                </span>
              </td>
              <CellEdit
                v-model="address[key]"
                :editing="editing"
                :address="address"
              />
            </tr>
          </template>
          <tr v-else>
            <td class="bold">
              <span class="ske">
                Adres:
              </span>
            </td>
            <td class="not-bold">
              <span class="ske">
                {{ `${address.street} ${address.houseNumber}${address.houseNumberExtension}` }}<br>{{ `${address.postalCode} ${address.city}` }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="bold">
              <span class="ske">
                Land:
              </span>
            </td>
            <td class="not-bold">
              <span class="ske">
                {{ countryStr }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="bold">
              <span class="ske">Tracking code:</span>
            </td>
            <td class="not-bold">
              <span v-if="!Array.isArray(order.shipmentTrackAndTrace)" class="shipment-track-and-trace ske">
                <a @click.stop v-if="getTrackAndTraceLink(order.shipmentTrackAndTrace)" :href="getTrackAndTraceLink(order.shipmentTrackAndTrace)" target="_blank">{{ order.shipmentTrackAndTrace }}</a>
                <span v-else>{{ order.shipmentTrackAndTrace || 'n.v.t' }}</span>
              </span>
              <div v-else @click.stop class="d-flex">
                <div class="shipment-track-and-trace">
                  <a class="track-link" @click.stop v-if="getTrackAndTraceLink(order.shipmentTrackAndTrace[0])" :href="getTrackAndTraceLink(order.shipmentTrackAndTrace[0])" target="_blank">{{ order.shipmentTrackAndTrace[0] }}</a>
                  <span v-else>{{ order.shipmentTrackAndTrace[0] }}</span>
                </div>

                <FormDropdown tag="div" :align-right="true" :remove-dropdown-tottle="true">
                  <template #title>
                    <span class="border extra-items">
                      {{ order.shipmentTrackAndTrace.length - 1 }}+
                    </span>
                  </template>
                  <button v-for="link in order.shipmentTrackAndTrace.slice(1)" class="dropdown-item" :key="link">
                    <a @click.stop v-if="getTrackAndTraceLink(link)" :href="getTrackAndTraceLink(link)" target="_blank">{{ link }}</a>
                    <span v-else>{{ link }}</span>
                  </button>
                </FormDropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex" v-if="editing">
      <button class="btn btn-success" @click="save">
        Wijzigingen opslaan
      </button>
      <button class="btn btn-danger" @click="cancel">
        Annuleren
      </button>
    </div>
  </div>
</template>

<script>

import CellEdit from "./CellEdit"
import FormDropdown from "@/components/FormDropdown.vue";

export default {
  components: {
    FormDropdown,
    CellEdit,
  },
  props: {
    loading: Boolean,
    order: Object,
    field: String,
  },
  data() {
    return {
      addressFieldMap: {
        Straat: "street",
        Huisnummer: "houseNumber",
        "Huisnummer Extensie": "houseNumberExtension",
        Postcode: "postalCode",
        Stad: "city",
      },
      editing: false,
      initialAddress: (this.order && this.order[this.field] && {...this.order[this.field]}) || {},
      address: (this.order && this.order[this.field]) || {}
    }
  },
  methods: {
    async save() {
      console.log(this.order, this.$route.params.id)
      await this.axios.put(`/api/orders/${this.order.uid || this.$route.params.id}`, {
        ...this.order,
        orders: this.order.orders.map(item => ({ ...item, price: parseFloat(item.price) })),
        [this.field]: {...this.address}
      })
      this.$store.dispatch('clearCacheSearch', "orders")
      this.$emit("reload")
      this.editing = false
    },
    cancel() {
      this.address = {...this.initialAddress}
      this.editing = false
    },
    getTrackAndTraceLink(trackingId) {
      const countryCode = this.address.countryCode
      const postalCode = this.address.postalCode;

      if (typeof trackingId !== 'string'
        || trackingId.length !== 13
        || !trackingId.toLowerCase().startsWith('3s')
        || !postalCode) {
        return false;
      }

      return `https://jouw.postnl.nl/track-and-trace/${trackingId}-${countryCode}-${postalCode}`
    },
  },
  computed: {
    countryCodeOptions() {
      return [
        {
          value: "NL",
          str: "Netherland",
        },
        {
          value: "BE",
          str: "Belgium",
        },
        {
          value: "DE",
          str: "Germany",
        },
        {
          value: "FR",
          str: "France",
        },
      ]
    },
    countryStr() {
      const address = this.address
      const countryCodeOptions = this.countryCodeOptions
      const countryName = address && countryCodeOptions.find(opt => opt.value === address.countryCode)

      return address && address.countryCode ? (countryName && countryName.str) || address.countryCode : 'n.v.t'
    },
  },
  watch: {
    order() {
      this.initialAddress = (this.order && this.order[this.field] && {...this.order[this.field]}) || {}
      this.address = (this.order && this.order[this.field]) || {}
    },
  },
}

</script>

<style scoped>

.OrderAddressEdit {
  position: relative;
  white-space: nowrap;
}

.btn {
  flex-basis: 50%;
  margin: 3px;
}

.btn:hover {
  filter: brightness(1.08);
}

.edit-button {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 11px;
  margin-right: 11px;
  cursor: pointer;
}

.bold {
  font-weight: 550;
}

td {
  padding-top: 11px;
}

tr {
  margin-right: 3px;
}

.not-bold {
  display: inline-block;
  margin-left: 8px;
}

.shipment-track-and-trace a,
.shipment-track-and-trace span {
  display: inline-block;
  padding-top: 8px;
}

.extra-items {
  background-color: white;
  padding: 4px 8px;
  border-radius: 4px;
}

</style>
